import React, { useEffect, useState } from "react";
import "../../center admin css/NewDashboardPage.css";
import { useNavigate } from "react-router-dom";
import api from "../../api/axiosConfig";
import { useMsal } from "@azure/msal-react";
import { useAppDispatch } from "../../app/hooks";
import { logout } from "../../features/auth/authSlice";
import LabReportsEntry from "../Center Admin/LabReportsEntry";
import CariogramReportEntry from "../Center Admin/CariogramReportEntry";

type CenterItem = {
  centerId: string;
  centerName: string;
  appointmentClusterId?: string;
  slots?: any[];
};

const NewDashboardPage = () => {
  const [activeTab, setActiveTab] = useState("today");
  const [selectedCenter, setSelectedCenter] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [availableDates, setAvailableDates] = useState<string[]>([]);
  const [cariogramDates, setCariogramDates] = useState<string[]>([]);
  const [centers, setCenters] = useState<CenterItem[]>([]);
  const [showLabReportEntry, setShowLabReportEntry] = useState(false);
  const [showCariogramEntry, setShowCariogramEntry] = useState(false);

  const navigate = useNavigate();
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    try {
      dispatch(logout());

      sessionStorage.clear();
      localStorage.clear();

      await instance.logoutRedirect({
        postLogoutRedirectUri: "/login",
      });
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  useEffect(() => {
    try {
      // ✅ READ FROM EXISTING STORED RESPONSE
      const storedConfig =
        sessionStorage.getItem("configResponse") ||
        localStorage.getItem("configResponse");

      if (!storedConfig) return;

      const parsedConfig = JSON.parse(storedConfig);

      // ✅ EXACT PATH FROM YOUR SCREENSHOT
      const assignedCenters = parsedConfig?.data || [];

      setCenters(assignedCenters);

      // ✅ AUTO SELECT IF ONLY ONE CENTER
    } catch (error) {
      console.error("Failed to load centers", error);
    }
  }, []);

  useEffect(() => {
    const fetchAvailableDates = async () => {
      try {
        if (
          !selectedCenter ||
          (activeTab !== "blood" && activeTab !== "cariogram")
        ) {
          setAvailableDates([]);
          setSelectedDate("");
          return;
        }

        const response = await api.centerworkflowApi.get(
          `/queues/B_AND_U_BLOOD_COLLECTED_Q/date-summary?centerId=${selectedCenter}`,
        );

        const dates = response?.data?.dates || [];

        const extractedDates = dates.map((item: any) => item.date);

        setAvailableDates(extractedDates);

        // ✅ OPTIONAL AUTO SELECT FIRST DATE
        // if (extractedDates.length > 0) {
        //   setSelectedDate(extractedDates[0]);
        // } else {
        //   setSelectedDate("");
        // }
        setSelectedDate("");
      } catch (error) {
        console.error("Failed to fetch available dates", error);
        setAvailableDates([]);
        setSelectedDate("");
      }
    };

    fetchAvailableDates();
  }, [selectedCenter, activeTab]);

  useEffect(() => {
    const fetchCariogramDates = async () => {
      if (activeTab !== "cariogram" || !selectedCenter) {
        setCariogramDates([]);
        setSelectedDate("");
        return;
      }

      try {
        const token = sessionStorage.getItem("accessToken");

        const response = await api.centerworkflowApi.get(
          `/queues/CARIOGRAM_INPUT_Q/date-summary?centerId=${selectedCenter}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const dates = response.data?.dates?.map((item: any) => item.date) || [];

        setCariogramDates(dates);

        // ✅ IMPORTANT
        setSelectedDate("");
      } catch (error) {
        console.error("Failed to fetch cariogram dates", error);

        setCariogramDates([]);
      }
    };

    fetchCariogramDates();
  }, [selectedCenter, activeTab]);

  return (
    <div className="welcome-container">
      {/* HEADER */}
      <div className="top-header">
        <div className="logo-section">
          <img src="/logo192.png" alt="logo" className="logo" />
          <span className="brand">QAVACH</span>
        </div>

        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      {/* WELCOME */}
      <div className="welcome-card">
        <h2>Welcome Center Admin!</h2>
      </div>

      {/* TABS */}
      <div className="tabs-container">
        <button
          className={activeTab === "today" ? "tab active" : "tab"}
          // onClick={() => setActiveTab("today")}
          onClick={() => {
            setActiveTab("today");
            setShowLabReportEntry(false);
            setShowCariogramEntry(false);
            setSelectedDate("");
          }}
        >
          Today’s Screenings
        </button>

        <button
          className={activeTab === "blood" ? "tab active" : "tab"}
          onClick={() => {
            setActiveTab("blood");
            setShowLabReportEntry(false);
            setShowCariogramEntry(false);
          }}
        >
          Lab Report Entry
        </button>

        <button
          className={activeTab === "cariogram" ? "tab active" : "tab"}
          onClick={() => {
            setActiveTab("cariogram");
            setShowLabReportEntry(false);
            setShowCariogramEntry(false);
          }}
        >
          Cariogram Report Entry
        </button>

        {/* <button
          className={activeTab === "dashboard" ? "tab active" : "tab"}
          onClick={() => {
            setActiveTab("dashboard");
            setShowLabReportEntry(false);
            setShowCariogramEntry(false);
          }}
        >
          Dashboards
        </button> */}
      </div>

      {/* CENTER SELECTION */}
      {/* {!(activeTab === "blood" && showLabReportEntry) && ( */}
      {!(
        (activeTab === "blood" && showLabReportEntry) ||
        (activeTab === "cariogram" && showCariogramEntry)
      ) && (
        <div className="center-select-section">
          <select
            className="center-dropdown"
            value={selectedCenter}
            onChange={(e) => setSelectedCenter(e.target.value)}
          >
            <option value="">Choose Center</option>

            {centers.map((center) => (
              <option key={center.centerId} value={center.centerId}>
                {center.centerName}
              </option>
            ))}
          </select>

          {/* SHOW DATE ONLY FOR BLOOD & CARIOGRAM */}
          {/* {(activeTab === "blood" || activeTab === "cariogram") && (
            <input
              type="date"
              className="center-dropdown"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          )} */}
          {/* 
          {(activeTab === "blood" || activeTab === "cariogram") && (
            <select
              className="center-dropdown"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            >
              <option value="">Choose Date</option>

              {availableDates.map((date) => (
                <option key={date} value={date}>
                  {date}
                </option>
              ))}
            </select>
          )} */}

          {selectedCenter &&
            (activeTab === "blood" || activeTab === "cariogram") && (
              // <select
              //   className="center-dropdown"
              //   value={selectedDate}
              //   onChange={(e) => setSelectedDate(e.target.value)}
              // >
              //   <option value="">Choose Date</option>

              //   {availableDates.map((date) => (
              //     <option key={date} value={date}>
              //       {date}
              //     </option>
              //   ))}
              // </select>
              <select
                className="center-dropdown"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              >
                <option value="">Choose Date</option>

                {(activeTab === "blood" ? availableDates : cariogramDates).map(
                  (date) => (
                    <option key={date} value={date}>
                      {date}
                    </option>
                  ),
                )}
              </select>
            )}

          {/* SHOW BUTTON ONLY WHEN NEEDED */}
          {(activeTab === "today" ||
            activeTab === "blood" ||
            activeTab === "cariogram") && (
            <button
              className="enter-btn"
              onClick={() => {
                // if (!selectedCenter) {
                //   alert("Please select center");
                //   return;
                // }
                if (!selectedCenter) {
                  alert("Please select center");
                  return;
                }

                if (
                  (activeTab === "blood" || activeTab === "cariogram") &&
                  !selectedDate
                ) {
                  alert("Please select date");
                  return;
                }

                const selectedCenterData = centers.find(
                  (c) => c.centerId === selectedCenter,
                );

                // ✅ STORE CENTER DETAILS
                sessionStorage.setItem("centerId", selectedCenter);

                localStorage.setItem("centerId", selectedCenter);

                sessionStorage.setItem(
                  "selectedCenterData",
                  JSON.stringify(selectedCenterData),
                );

                // ✅ STORE DATE
                sessionStorage.setItem("selectedDate", selectedDate);

                // ✅ // ✅ ACTIONS
                if (activeTab === "today") {
                  navigate("/welcome_screen");
                } else {
                  sessionStorage.removeItem("selectedPatient_LAB_REPORTS_Q");
                }

                // ✅ SHOW LAB REPORT ENTRY INSIDE PAGE
                // if (activeTab === "blood") {
                //   setShowLabReportEntry(true);
                // }

                // if (activeTab === "cariogram") {
                //   navigate("/cariogram-report-entry");
                // }

                if (activeTab === "blood") {
                  setShowLabReportEntry(true);

                  setShowCariogramEntry(false);
                }

                if (activeTab === "cariogram") {
                  setShowCariogramEntry(true);

                  setShowLabReportEntry(false);
                }
              }}
            >
              Enter
            </button>
          )}
        </div>
      )}

      {/* LAB REPORT ENTRY */}
      {/* {activeTab === "blood" && showLabReportEntry && <LabReportsEntry />} */}
      {/* LAB REPORT ENTRY */}
      {activeTab === "blood" && showLabReportEntry && <LabReportsEntry />}

      {/* CARIOGRAM ENTRY */}
      {activeTab === "cariogram" && showCariogramEntry && (
        <CariogramReportEntry />
      )}
    </div>
  );
};

export default NewDashboardPage;
